<template>
  <b-modal
    v-model="isShow"
    @hidden="
      () => {
        $emit('update:isShow', false);
      }
    "
    @shown="openForm"
    dialog-class="dialog-class"
    centered
  >
    <template #modal-header="{ close }">
      <h4 class="mb-0 text-primary">
        {{ $t(data ? "ar_client_update_group_user" : "ar_client_add_group_user") }}
      </h4>
      <!--  <h4 class="mb-0 text-primary" v-else>
          {{ $t("ar_client_update_debit_account") }}
        </h4> -->
      <ez-icon
        icon="ezAr-icon-x"
        size="24"
        class="cursor-pointer"
        color="#114A9F"
        @click="close()"
      />
    </template>
    <FormItems ref="formRef" :items="formItems" :formData.sync="formData" />
    <template #modal-footer="">
      <b-button :disabled="isLoading" @click="createUpdateGroupUser" variant="primary">
        {{ $t("ar_common_save") }}
      </b-button>
    </template>
  </b-modal>
</template>
<style lang="scss" scoped>
::v-deep .dialog-class {
  max-width: 650px !important;
}
</style>
<script>
import { computed, ref, defineComponent, getCurrentInstance } from "@vue/composition-api";

import FormItems from "../../ultils/Form/FormItems.vue";
import { useFetch } from "../../ultils/Hooks/useFetch.ts";
import { CommonActiveStatus } from "../../ultils/status";

import { arClient } from "@/api/ar-client";
import _ from "lodash";
import { TaUserGroupType } from "../../ultils/status";
export default defineComponent({
  name: "ModalGroupUser",
  components: {
    FormItems,
  },
  props: {
    data: Object,
    isShow: Boolean,
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy;
    const formRef = ref();
    const taUserGroupType = computed(() => {
      let temp = Object.values(TaUserGroupType);
      if ((vm.isSuperAdmin && !props.data) || !vm.isSuperAdmin) {
        temp = temp.filter((type) => type !== TaUserGroupType.SUPERADMIN);
      }

      return temp;
    });

    const formData = ref({
      TaUserGroupType: TaUserGroupType.USER,
    });

    const formItems = computed(() => [
      {
        type: "cleave",
        cleaveType: "uppercase",
        disabled: props.data,
        name: "TaUserGroupCode",
        rules: { code: true, max: 20, min: 2 },

        required: true,
        label: "ar_client_group_code",
      },

      {
        type: "string",

        name: "NameVi",

        required: true,
        label: "ar_client_group_name",
      },
      {
        disabled: props.data || !vm.isSuperAdmin,
        type: "select",
        dataSource: taUserGroupType.value,
        required: true,
        name: "TaUserGroupType",

        label: "ar_client_group_type",
      },
      {
        type: "select",
        required: true,
        disabled: props.data,
        name: "TravelAgentId",
        dataSource: arClient.api_AR_RCL01,
        dataSourceParams: {
          IsCheckPermission: false,
        },
        customOptions: (options) =>
          options.map((option) => ({
            ...option,
            CodeName: `${option.TravelAgentCode} - ${option.NameVi}`,
          })),
        labelOption: "CodeName",
        label: "ar_client_company",
        placeholder: "ar_client_company",
      },
      {
        hide: !props.data || formData.value.TaUserGroupType === TaUserGroupType.SUPERADMIN,
        type: "select",
        dataSource: CommonActiveStatus.map((stt) => ({ Label: vm.$t(stt.title), Id: stt.value })),
        noClearable: true,
        name: "InActive",
        labelOption: "Label",
        label: "ar_client_status",
        wrapperClass: "col-6",
      },
      {
        type: "string",
        variant: "textarea",
        name: "DescriptionVi",

        wrapperClass: "col-12",
        label: "ar_client_description",
      },
    ]);

    const { fetchData: mutationGroupUser, isLoading } = useFetch(
      props.data ? arClient.api_AP_UTUG01 : arClient.api_AP_ITUG01,
      {
        showLoading: true,

        nextFunction: (data) => {
          emit("refetch");
          emit("update:isShow", false);
        },
      }
    );

    const createUpdateGroupUser = () => {
      formRef.value.validate().then((success) => {
        if (success) {
          mutationGroupUser({ TaUserGroup: { ...formData.value } });
        }
      });
    };
    const openForm = () => {
      if (props.data) {
        const temp = { ...formData.value };
        _.forEach(props.data, (v, key) => {
          if (formItems.value.map((item) => item.name).includes(key)) {
            temp[key] = v;
          }
        });

        formData.value = { ...temp, Id: props.data.Id };
      }
    };

    return { isLoading, formData, formItems, createUpdateGroupUser, formRef, openForm };
  },
  methods: {
    test() {},
  },
});
</script>
